
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["fill-current w-16 h-16 inline-block text-black mr-1",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.674 9.138l-1.2-1.207V4.958A4.573 4.573 0 006.594.371a4.493 4.493 0 00-5.08 4.447v3.114l-1.2 1.206a1.093 1.093 0 00.773 1.86h2.24v.227a2.56 2.56 0 002.667 2.44 2.56 2.56 0 002.667-2.44v-.227h2.24a1.093 1.093 0 00.773-1.86zm-4.347 2.087a1.253 1.253 0 01-1.333 1.107 1.253 1.253 0 01-1.333-1.107v-.227h2.666v.227zm-5.66-1.56l.787-.787c.252-.25.394-.591.393-.947V4.819a3.155 3.155 0 011.08-2.373 3.113 3.113 0 012.494-.78A3.24 3.24 0 019.14 4.93v3c-.002.355.137.696.386.947l.794.787H1.667z","fill":"#000"}})])
          )
        }
      }
    